module.exports = __webpack_public_path__ + "static/vascepaCapsule-8c44466b006abde0a2d11019b04c0314.png";